import { render, staticRenderFns } from "./AdminProjectDelete.vue?vue&type=template&id=38f26f6c&scoped=true"
import script from "./AdminProjectDelete.vue?vue&type=script&lang=js"
export * from "./AdminProjectDelete.vue?vue&type=script&lang=js"
import style0 from "./AdminProjectDelete.vue?vue&type=style&index=0&id=38f26f6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f26f6c",
  null
  
)

export default component.exports